import { useMemo } from 'react';

const useBreadcrumbs = (path: string, customNames: Record<string, string> = {}) => {
  const crumbs = useMemo(() => {
    let accumulatedPath = '';
    const links = path
      .split('/')
      .filter(link => link !== '' && !(/\d/.test(link)) && link !== 'page')
      .map(link => {
        accumulatedPath += `/${link}`;
        return {
          name: customNames[link] || link.charAt(0).toUpperCase() + link.slice(1).replace(/-/g, ' '),
          path: accumulatedPath
        };
      });

    return [{ name: 'Home', path: '/' }, ...links];
  }, [path, customNames]);

  return crumbs;
};

export default useBreadcrumbs;
